exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.accordion[data-v-eca53640] {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  background: none;\n}\n.accordion__item[data-v-eca53640]:last-child {\n    border-bottom: none;\n}\n", ""]);

// exports
